var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwittericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3093,
    r: 14,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3093,
    r: 13.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2071 11.2923C19.7881 11.4785 19.3458 11.5949 18.8802 11.6648C19.3458 11.3854 19.7183 10.9431 19.8812 10.4077C19.4389 10.6638 18.9501 10.85 18.4146 10.9664C17.9956 10.5241 17.3904 10.2448 16.7386 10.2448C15.4815 10.2448 14.4572 11.269 14.4572 12.5261C14.4572 12.7123 14.4805 12.8753 14.5271 13.0382C12.6415 12.9451 10.9421 12.0372 9.80141 10.6405C9.61518 10.9897 9.49878 11.3621 9.49878 11.7812C9.49878 12.5727 9.89453 13.271 10.5231 13.69C10.1506 13.6668 9.80141 13.5737 9.4755 13.4107V13.434C9.4755 14.5514 10.267 15.4825 11.3145 15.692C11.1283 15.7386 10.9188 15.7619 10.7093 15.7619C10.5696 15.7619 10.4067 15.7386 10.267 15.7153C10.5696 16.6232 11.4077 17.2983 12.4087 17.2983C11.6172 17.9035 10.6395 18.276 9.56862 18.276C9.38239 18.276 9.19616 18.276 9.0332 18.2527C10.0575 18.9045 11.2447 19.277 12.5483 19.277C16.7618 19.277 19.0665 15.7852 19.0665 12.7589C19.0665 12.6658 19.0665 12.5494 19.0665 12.4563C19.5088 12.1536 19.9045 11.7579 20.2071 11.2923Z",
    fill: "#2C444E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittericon);
export default __webpack_public_path__ + "static/media/twittericon.92b59a0a79140960777a3059eb234738.svg";
export { ForwardRef as ReactComponent };